import { css } from 'styled-components';

interface IconWrapperProps {
  active?: boolean;
}

const InputDatepickerIconWrapper = css <IconWrapperProps>`
  svg {
    stroke: none;
    fill: #8295A3;
    use, g, path {
      fill: #8295A3;
    }
  }
  ${({ active }) => active && `
    svg {
      fill: #5DC5EA;
      use, g, path{
        fill: #5DC5EA;
      }
    }
  `}
`;

export default InputDatepickerIconWrapper;
